import React from "react";
import { Formik, Form } from "formik";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
// import CustomInput from "../views/custom/CustomInput";
import * as Yup from "yup";
import { connect } from "react-redux";
import { registerUser } from "../Redux/Creators/RegisterUserCreators";
import history from "../myCreatedHistory";
import AuthNavbar from "components/Navbars/AuthNavbar.js";
import AuthFooter from "components/Footers/AuthFooter.js";
import { Switch } from "react-router-dom";
import { MenuItem, TextField } from "@mui/material";
import moment from "moment";


const RegisterUser = (props) => {
  const mainContent = React.useRef(null);
  // const navigate = useNavigate();
  // const dispatch = useDispatch();
  // const toggle = () => {
  //   history.push(`/login`);
  //   window.location.reload();
  // };
  const handleSubmit = (values, setSubmitting) => {
    console.log("handleSubmit","handleSubmit")
    // let data = {
    //   name: values.name,
    //   email: values.email,
    //   role: values.role,
    //   status: values.status,
    //   password: values.password,
    //   password_confirmation: values.password_confirmation,
    //   mobile_no: values.mobile_no,
    //   designation: values.designation,
    //   join_date: values.join_date,
    //   pincode: values.pincode,
    //   marksheet: values.marksheet,
    //   kyc: values.kyc,
    //   personal_contact: values.personal_contact,
    //   father_contact: values.father_contact,
    //   mother_contact: values.mother_contact,
    //   adhaar_card_file: values.adhaar_card_file,
    //   pancard_file: values.pancard_file,
    //   cv_file: values.cv_file,
    //   offerletter: values.offerletter,
    //   city: values.city,
    // };
    let data = new FormData();

    data.append("name", values.name);
    data.append("email", values.email);
    data.append("role", values.role);
    data.append("password", values.password);
    data.append("password_confirmation", values.password_confirmation);
    data.append("mobile_no", values.mobile_no);
    data.append("designation", values.designation);
    data.append("join_date", values.join_date);
    data.append('pincode', values.pincode);
    // data.append("status", values.status);
    // data.append("user_pincodes", JSON.stringify(values.user_pincodes));
    // data.append("banks", values.banks);
//     data.append("branch_master_id", values.branch_master_id);
//     // data.append("case_types", values.case_types);
//     data.append("user_type", values.user_type);
//     data.append("ref_name", values.ref_name);
//     data.append("ref_number", values.ref_number);
//     data.append("adhaar_no", values.adhaar_no);
//     data.append("address", values.address);
//     data.append("pancard_no", values.pancard_no);
//     data.append("account_number", values.account_number);
//     data.append("acc_name", values.acc_name);
//     data.append("ifsc_code", values.ifsc_code);
//     data.append("branch_name", values.branch_name);
//     data.append("joing_type", values.joing_type);
//     data.append("branch_head_approval", values.branch_head_approval);
//     data.append("master_approval", values.master_approval);
//     data.append("cv_file", values.cv_file);
//     data.append("adhaar_card_file", values.adhaar_card_file);
//     data.append("adhaar_card_file", values.adhaar_card_file);
//     data.append("kyc", values.kyc);
//     data.append("marksheet", values.marksheet);
//     data.append("driving_licence_file", values.driving_licence_file);
//     data.append("photograph", values.photograph);
//     data.append("bank_name", values.emp_bank_name);
//     data.append('personal_contact', values.personal_contact);
// data.append('father_contact', values.father_contact);
// data.append('mother_contact', values.mother_contact);
// data.append('mother_contact', values.mother_contact);
    // dispatch(actions.registerUser(data, toggle));
    props.registerUser(data);
    setSubmitting(false);
    return;
  };
  return (
    <React.Fragment>
      <div className="main-content" style={{"background-color": "#172b4d"}} ref={mainContent}>
        <AuthNavbar />
        <div className="header bg-gradient-info py-7 py-lg-8">
          <Container>
            <div className="header-body text-center mb-7">
              <Row className="justify-content-center">
                <Col lg="5" md="6">
                  <h1 className="text-white">Welcome!</h1>
                </Col>
              </Row>
            </div>
          </Container>
          <div className="separator separator-bottom separator-skew zindex-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-default"
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div>
        </div>
        {/* Page content */}
        <Container className="mt--9 pb-5">
          <Row className="justify-content-center">
            <Switch>
              <>
                <Col lg="10" md="7">
                  <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-transparent pb-1 text-blue h2"></CardHeader>

                    <CardBody className="px-lg-5 py-lg-5">
                      <div className="text-center text-muted mb-4">
                        <small>Register</small>
                      </div>
                      <Formik
                        initialValues={{
                          name: "",
                          email: "",
                          role: "N/A",
                          status: "",
                          password: "",
                          password_confirmation: "",
                          mobile_no: "",
                          designation: "N/A",
                          join_date: moment().format("YYYY-MM-DD"),
          
                          //*Array
          
                          banks: [],
                          banks_temp: [],
                          pincode_array: [],
                          pincode: "",
                          pincode_id: [],
                          user_pincodes: [],
                          bank_name: "",
                          bank_id: "",
                          branch_master_id: "",
                          case_types: [],
                          user_type: "",
                          ref_name: "",
                          ref_number: "",
                          adhaar_no: "",
                          address: "",
                          pancard_no: "",
                          account_number: "",
                          acc_name: "",
                          ifsc_code: "",
                          emp_bank_name: "",
                          branch_name: "",
                          joing_type: "",
                          branch_head_approval: "No",
                          master_approval: "Mo",
                          driving_licence_file: "",
                          photograph: "",
                          marksheet: "",
                          kyc: "",
                          cv_file: "",
                          adhaar_card_file: "",
                          pancard_file: "",
                          personal_contact: "",
                          father_contact: "",
                          mother_contact: "",
                        }}
                        onSubmit={handleSubmit}
                        validationSchema={Yup.object().shape({
                          name: Yup.string().required("Name is required"),
                          email: Yup.string().required("Email is required"),
                          // role: Yup.string().required("Role is required"),
                          // status: Yup.string().required("Status is required"),
                          // password: Yup.string().required(
                          //   "Password is required"
                          // ),
                          // password_confirmation: Yup.string().oneOf(
                          //   [Yup.ref("password"), null],
                          //   "Passwords must match"
                          // ),
                          // mobile_no: Yup.string().required(
                          //   "Mobile No. is required"
                          // ),
                          // designation: Yup.string().required(
                          //   "Designation is required"
                          // ),
                          // join_date: Yup.string().required(
                          //   "Joining Date is required"
                          // ),
                        })}
                      >
                        {(formProps) => (
                          <Form role="form">
                            <Row>
                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          label="Name"
                          id="name"
                          name="name"
                          value={formProps.values.name}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.name &&
                            Boolean(formProps.errors.name)
                          }
                          helperText={
                            formProps.touched.name && formProps.errors.name
                          }
                        />
                      </Col>

                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          type="email"
                          size="small"
                          variant="outlined"
                          id="email"
                          name="email"
                          label="Personal Email Id"
                          value={formProps.values.email}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.email &&
                            Boolean(formProps.errors.email)
                          }
                          helperText={
                            formProps.touched.email && formProps.errors.email
                          }
                        />
                      </Col>

                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          id="mobile_no"
                          name="mobile_no"
                          label="Mobile Number"
                          value={formProps.values.mobile_no}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.mobile_no &&
                            Boolean(formProps.errors.mobile_no)
                          }
                          helperText={
                            formProps.touched.mobile_no &&
                            formProps.errors.mobile_no
                          }
                        />
                      </Col>

     
                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          id="address"
                          name="address"
                          label="Address"
                          value={formProps.values.address}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.address &&
                            Boolean(formProps.errors.address)
                          }
                          helperText={
                            formProps.touched.address &&
                            formProps.errors.address
                          }
                        />
                      </Col>
                                       <Col md={6} style={{ paddingBottom: "20px" }}>
  <TextField
    fullWidth
    size="small"
    variant="outlined"
    id="pincode"
    name="pincode"
    label="Pincode"
    value={formProps.values.pincode}
    onChange={formProps.handleChange}
    error={
      formProps.touched.pincode && Boolean(formProps.errors.pincode)
    }
    helperText={
      formProps.touched.pincode && formProps.errors.pincode
    }
  />
</Col>

                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          type="date"
                          variant="outlined"
                          id="join_date"
                          name="join_date"
                          label="Joining Date"
                          value={formProps.values.join_date}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.join_date &&
                            Boolean(formProps.errors.join_date)
                          }
                          helperText={
                            formProps.touched.join_date && formProps.errors.join_date
                            }
                        >
                          </TextField>
                          </Col>

                    </Row>

                    <Row>
                     
<Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          type="password"
                          size="small"
                          variant="outlined"
                          id="password"
                          name="password"
                          label="Password"
                          value={formProps.values.password}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.password &&
                            Boolean(formProps.errors.password)
                          }
                          helperText={
                            formProps.touched.password &&
                            formProps.errors.password
                          }
                        />
                      </Col>

                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          type="password"
                          id="password_confirmation"
                          name="password_confirmation"
                          label="Confirm Password"
                          value={formProps.values.password_confirmation}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.password_confirmation &&
                            Boolean(formProps.errors.password_confirmation)
                          }
                          helperText={
                            formProps.touched.password_confirmation &&
                            formProps.errors.password_confirmation
                          }
                        />
                      </Col>

{/* <Col md={6} style={{ paddingBottom: "20px" }}>
  <TextField
    fullWidth
    required
    size="small"
    variant="outlined"
    id="personal_contact"
    name="personal_contact"
    label="Personal Contact"
    value={formProps.values.personal_contact}
    onChange={formProps.handleChange}
    error={
      formProps.touched.personal_contact &&
      Boolean(formProps.errors.personal_contact)
    }
    helperText={
      formProps.touched.personal_contact && formProps.errors.personal_contact
    }
  />
</Col>

<Col md={6} style={{ paddingBottom: "20px" }}>
  <TextField
    fullWidth
    required
    size="small"
    variant="outlined"
    id="father_contact"
    name="father_contact"
    label="Father Contact"
    value={formProps.values.father_contact}
    onChange={formProps.handleChange}
    error={
      formProps.touched.father_contact &&
      Boolean(formProps.errors.father_contact)
    }
    helperText={
      formProps.touched.father_contact && formProps.errors.father_contact
    }
  />
</Col>

<Col md={6} style={{ paddingBottom: "20px" }}>
  <TextField
    fullWidth
    required
    size="small"
    variant="outlined"
    id="mother_contact"
    name="mother_contact"
    label="Mother Contact"
    value={formProps.values.mother_contact}
    onChange={formProps.handleChange}
    error={
      formProps.touched.mother_contact &&
      Boolean(formProps.errors.mother_contact)
    }
    helperText={
      formProps.touched.mother_contact && formProps.errors.mother_contact
    }
  />
</Col>
                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          id="ref_name"
                          name="ref_name"
                          label="Reference Name"
                          value={formProps.values.ref_name}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.ref_name &&
                            Boolean(formProps.errors.ref_name)
                          }
                          helperText={
                            formProps.touched.ref_name &&
                            formProps.errors.ref_name
                          }
                        />
                      </Col>

                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          id="ref_number"
                          name="ref_number"
                          label="Reference Number"
                          value={formProps.values.ref_number}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.ref_number &&
                            Boolean(formProps.errors.ref_number)
                          }
                          helperText={
                            formProps.touched.ref_number &&
                            formProps.errors.ref_number
                          }
                        />
                      </Col>

                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          id="adhaar_no"
                          name="adhaar_no"
                          label="Aadhaar Number"
                          value={formProps.values.adhaar_no}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.adhaar_no &&
                            Boolean(formProps.errors.adhaar_no)
                          }
                          helperText={
                            formProps.touched.adhaar_no &&
                            formProps.errors.adhaar_no
                          }
                        />
                      </Col>

                      

                    
                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          id="pancard_no"
                          name="pancard_no"
                          label="PAN Card Number"
                          value={formProps.values.pancard_no}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.pancard_no &&
                            Boolean(formProps.errors.pancard_no)
                          }
                          helperText={
                            formProps.touched.pancard_no &&
                            formProps.errors.pancard_no
                          }
                        />
                      </Col>

                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          id="account_number"
                          name="account_number"
                          label="Account Number"
                          value={formProps.values.account_number}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.account_number &&
                            Boolean(formProps.errors.account_number)
                          }
                          helperText={
                            formProps.touched.account_number &&
                            formProps.errors.account_number
                          }
                        />
                      </Col>

                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          id="acc_name"
                          name="acc_name"
                          label="Account Name"
                          value={formProps.values.acc_name}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.acc_name &&
                            Boolean(formProps.errors.acc_name)
                          }
                          helperText={
                            formProps.touched.acc_name &&
                            formProps.errors.acc_name
                          }
                        />
                      </Col>

                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          id="ifsc_code"
                          name="ifsc_code"
                          label="IFSC Code"
                          value={formProps.values.ifsc_code}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.ifsc_code &&
                            Boolean(formProps.errors.ifsc_code)
                          }
                          helperText={
                            formProps.touched.ifsc_code &&
                            formProps.errors.ifsc_code
                          }
                        />
                      </Col>

                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          id="emp_bank_name"
                          name="emp_bank_name"
                          label="Bank Name"
                          value={formProps.values.emp_bank_name}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.emp_bank_name &&
                            Boolean(formProps.errors.emp_bank_name)
                          }
                          helperText={
                            formProps.touched.emp_bank_name &&
                            formProps.errors.emp_bank_name
                          }
                        />
                      </Col>

                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          id="branch_name"
                          name="branch_name"
                          label="Branch Name"
                          value={formProps.values.branch_name}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.branch_name &&
                            Boolean(formProps.errors.branch_name)
                          }
                          helperText={
                            formProps.touched.branch_name &&
                            formProps.errors.branch_name
                          }
                        />
                      </Col>

                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          select
                          size="small"
                          variant="outlined"
                          id="joing_type"
                          name="joing_type"
                          label="Joining Type"
                          value={formProps.values.joing_type}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.joing_type &&
                            Boolean(formProps.errors.joing_type)
                          }
                          helperText={
                            formProps.touched.joing_type &&
                            formProps.errors.joing_type
                          }
                        >
                          <MenuItem value={""}>Select</MenuItem>
                          <MenuItem value={"Full Time"}>Full Time</MenuItem>
                          <MenuItem value={"Part Time"}>Part Time</MenuItem>
                        </TextField>
                      </Col>

                      {props.login?.login?.users?.role === "admin" ? 
                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          select
                          size="small"
                          variant="outlined"
                          id="branch_head_approval"
                          name="branch_head_approval"
                          label="Branch Head Approval"
                          value={formProps.values.branch_head_approval}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.branch_head_approval &&
                            Boolean(formProps.errors.branch_head_approval)
                          }
                          helperText={
                            formProps.touched.branch_head_approval &&
                            formProps.errors.branch_head_approval
                          }
                          >
                          <MenuItem value={""}>Select</MenuItem>
                          <MenuItem value={"Yes"}>Yes</MenuItem>
                          <MenuItem value={"No"}>No</MenuItem>
                        </TextField>
                      </Col>
                      : ""}

                      
                      {props.login?.login?.users?.role === "Master" ? 
                      <Col md={6} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          select
                          size="small"
                          variant="outlined"
                          id="master_approval"
                          name="master_approval"
                          label="Master Approval"
                          value={formProps.values.master_approval}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.master_approval &&
                            Boolean(formProps.errors.master_approval)
                          }
                          helperText={
                            formProps.touched.master_approval &&
                            formProps.errors.master_approval
                          }
                          >
                          <MenuItem value={""}>Select</MenuItem>
                          <MenuItem value={"Yes"}>Yes</MenuItem>
                          <MenuItem value={"No"}>No</MenuItem>
                        </TextField>
                      </Col>
                          :""}

                      <Col md={6} style={{ paddingBottom: "20px" }}>
                      <Label className="label f-12">Photograph</Label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="file"
                        id="photograph"
                        name="photograph"
                        onChange={(e) => {
                          formProps.setFieldValue(
                            "photograph",
                            e.currentTarget.files[0]
                          );
                        }}
                      />
                      </Col>
                     
                      <Col md={6} style={{ paddingBottom: "20px" }}>
                      <Label className="label f-12">Driving Licence</Label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="file"
                        id="driving_licence_file"
                        name="driving_licence_file"
                        onChange={(e) => {
                          formProps.setFieldValue(
                            "driving_licence_file",
                            e.currentTarget.files[0]
                          );
                        }}
                      />
                      </Col>
                      <Col md={6} style={{ paddingBottom: "20px" }}>
                      <Label className="label f-12">Adhaar Card</Label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="file"
                        id="adhaar_card_file"
                        name="adhaar_card_file"
                        onChange={(e) => {
                          formProps.setFieldValue(
                            "adhaar_card_file",
                            e.currentTarget.files[0]
                          );
                        }}
                      />
                      </Col>

                      <Col md={6} style={{ paddingBottom: "20px" }}>
                      <Label className="label f-12">Pancard</Label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="file"
                        id="pancard_file"
                        name="pancard_file"
                        onChange={(e) => {
                          formProps.setFieldValue(
                            "pancard_file",
                            e.currentTarget.files[0]
                          );
                        }}
                      />
                      </Col>
                      <Col md={6} style={{ paddingBottom: "20px" }}>
                      <Label className="label f-12">CV File</Label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="file"
                        id="cv_file"
                        name="cv_file"
                        onChange={(e) => {
                          formProps.setFieldValue(
                            "cv_file",
                            e.currentTarget.files[0]
                          );
                        }}
                      />
                      </Col>
                      <Col md={6} style={{ paddingBottom: "20px" }}>
                      <Label className="label f-12">Marksheet</Label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="file"
                        id="marksheet"
                        name="marksheet"
                        onChange={(e) => {
                          formProps.setFieldValue(
                            "marksheet",
                            e.currentTarget.files[0]
                          );
                        }}
                      />
                      </Col>
                      <Col md={6} style={{ paddingBottom: "20px" }}>
                      <Label className="label f-12">KYC</Label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="file"
                        id="kyc"
                        name="kyc"
                        onChange={(e) => {
                          formProps.setFieldValue(
                            "kyc",
                            e.currentTarget.files[0]
                          );
                        }}
                      />
                      </Col>


                      <Col md={12} style={{ paddingBottom: "20px" }}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          id="designation"
                          name="designation"
                          label="Designation"
                          value={formProps.values.designation}
                          onChange={formProps.handleChange}
                          error={
                            formProps.touched.designation &&
                            Boolean(formProps.errors.designation)
                          }
                          helperText={
                            formProps.touched.designation &&
                            formProps.errors.designation
                          }
                        />
                      </Col>
                      <Col
                        md={12}
                        className=""
                        style={{ paddingBottom: "20px" }}
                      >
                        <TextField
                          fullWidth
                          variant="outlined"
                          select
                          type="select"
                          size="small"
                          label="Branch Master"
                          id="branch_master_id"
                          name="branch_master_id"
                          value={formProps.values.branch_master_id}
                          onChange={formProps.handleChange}
                        >
                          <MenuItem value="">Select</MenuItem>
                          {props.branchMaster?.branchMaster?.map((user, id) => {
                            return (
                              <MenuItem value={user.id}>
                                {`${user?.company_detail?.company_detail}, ${user?.branch_name}`}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </Col>
                      <Col md={12} className="pb-4">
                        <TextField
                          fullWidth
                          select
                          size="small"
                          variant="outlined"
                          id="user_type"
                          name="user_type"
                          label="User Type"
                          value={formProps.values.user_type}
                          onChange={formProps.handleChange}
                        >
                          <MenuItem value="">Select</MenuItem>
                          <MenuItem value="0">Libra</MenuItem>
                          <MenuItem value="1">Libra Unstructured</MenuItem>
                        </TextField>
                      </Col>

                       */}
                    </Row>
                            {/* <div className="custom-control custom-control-alternative custom-checkbox">
                              <input
                                className="custom-control-input"
                                id=" customCheckLogin"
                                type="checkbox"
                              />
                              <label
                                className="custom-control-label"
                                htmlFor=" customCheckLogin"
                              >
                                <span className="text-muted">Remember me</span>
                              </label>
                            </div> */}
                            <div className="text-center">
                              {/* <Button
                      className="my-4"
                      color="primary"
                      type="submit"
                      disabled={formProps.isSubmitting}
                    >
                      Sign in
                    </Button> */}
                              <Button
                                className="my-4"
                                type="submit"
                                // disabled={formProps.isSubmitting}
                                color="primary"
                              >
                                Register
                              </Button>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </CardBody>
                  </Card>
                  <Row className="mt-3">
                    <Col xs="6">
                      <Link
                        className="text-light"
                        to="/forgot-password"
                        style={{ textDecoration: "none" }}
                      >
                        {/* <a
              className="text-light"
              href="#pablo"
              onClick={(e) => e.preventDefault()}
            > */}
                        <small>Forgot password?</small>
                        {/* </a> */}
                      </Link>
                    </Col>
                    <Col className="text-right" xs="6">
                      <Link
                        className="text-right"
                        to="/register-docs"
                        xs="6"
                        style={{ textDecoration: "none" }}
                      >
                        {/* <a
              className="text-light"
              href="#pablo"
              onClick={(e) => e.preventDefault()}
            > */}
                        <small>Upload Docs</small>
                        {/* </a> */}
                      </Link>
                    </Col>
                  </Row>
                </Col>
              </>
            </Switch>
          </Row>
        </Container>
      </div>
      <AuthFooter />
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    login: state.login,
  };
};

const mapDispatchToProps = (dispatch) => ({
  registerUser: (data) => {
    dispatch(registerUser(data));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(RegisterUser);
